/* eslint-disable no-nested-ternary */
import axios from 'axios';
import { IStepInfo } from '../components/damageReportForm/stepInfo/stepInfo.schema';
import { IStepInfoAboutDamage } from '../components/damageReportForm/stepInfoAboutDamage/stepInfoAboutDamage.schema';
import { IStepPaymentInfo } from '../components/damageReportForm/stepPaymentInfo/stepPaymentInfo.schema';
import {
	DAMAGE_REPORT_OPTIONS_SELECTED,
	STEP_INFO_ABOUT_DAMAGE_FULFILLED,
	STEP_INFO_FULFILLED,
	STEP_PAYMENT_INFO_FULFILLED,
	SUBMIT_REPORT_FAILED,
	SUBMIT_REPORT_FULFILLED,
	SUBMIT_REPORT_PENDING,
} from '../constants/actions/damageReportActions';
import { DAMAGE_REPORT_POST } from '../constants/paths/api';
import { getDamageReportDataModel } from '../helpers/apiHelpers/damageReportHerlpers';
import { getCurrentLangPretty } from '../helpers/url/urlHelpers';
import { IDamageReportReducer } from '../reducers/damageReportReducer';

export const stepInfoAboutDamageUpdate = values => ({
	type: DAMAGE_REPORT_OPTIONS_SELECTED,
	payload: {
		values,
	},
});

export const stepInfoAboutDamageFulfilled = (values: IStepInfoAboutDamage, stepInfoValues: IStepInfo) => ({
	type: STEP_INFO_ABOUT_DAMAGE_FULFILLED,
	payload: { values, stepInfoValues },
});

export const stepInfoFulfilled = (values: IStepInfo) => ({
	type: STEP_INFO_FULFILLED,
	payload: {
		values,
	},
});

export const stepPaymentInfoFulfilled = (values: IStepPaymentInfo) => ({
	type: STEP_PAYMENT_INFO_FULFILLED,
	payload: {
		values,
	},
});

export const submitReportFulfilled = () => ({
	type: SUBMIT_REPORT_FULFILLED,
});

export const submitReportFailed = (errorMessage: string) => ({
	type: SUBMIT_REPORT_FAILED,
	payload: {
		errorMessage,
	},
});

export const submitReportPending = () => ({
	type: SUBMIT_REPORT_PENDING,
	payload: null,
});

export const submitReport = (staffEmail: string) => {
	return async (dispatch, getState) => {
		const { damageReportReducer }: { damageReportReducer: IDamageReportReducer } = getState();
		const damageReportDataModel = getDamageReportDataModel(damageReportReducer);

		dispatch(submitReportPending());
		try {
			const formData = new FormData();
			formData.append('Info', JSON.stringify(damageReportDataModel.Info));
			formData.append('Sender', JSON.stringify(damageReportDataModel.Sender));
			formData.append('Receiver', JSON.stringify(damageReportDataModel.Receiver));
			formData.append('PaymentInfo', JSON.stringify(damageReportDataModel.PaymentInfo));
			formData.append('staffEmail', staffEmail);

			if (damageReportDataModel.Files) {
				damageReportDataModel.Files.forEach(file => {
					formData.append('Files', file);
				});
			} else {
				formData.append('Files', null);
			}

			if (damageReportDataModel.Images) {
				damageReportDataModel.Images.forEach(image => {
					formData.append('Images', image);
				});
			} else {
				formData.append('Images', null);
			}
			await axios.post(`${DAMAGE_REPORT_POST}`, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			});

			dispatch(submitReportFulfilled());
		} catch (error) {
			dispatch(
				submitReportFailed(
					error.response
						? error.response.data.details
						: getCurrentLangPretty() === 'en'
						? 'An error occurred. Sorry, the Report damage could not be submitted. Please contact us tjonamal@postur.is'
						: 'Upp kom villa. Því miður tókst ekki að senda inn tjónaskýrslu. Vinsamlegast hafðu samband við tjonamal@postur.is'
				)
			);
		}
	};
};
